const cartAndOrderLimits = 20

export default cartAndOrderLimits
